import { useState } from 'react';
import {
  FxImageContainer, // eslint-disable-line no-unused-vars
  FxActionCard, // eslint-disable-line no-unused-vars
  FxBreadcrumbs, // eslint-disable-line no-unused-vars
  FxPageContainer, // eslint-disable-line no-unused-vars
} from 'axp-fx-common';
import { browserHistory } from '@americanexpress/one-app-router';
import { manageContactActions } from './manageContactsInitData';
import { manageContactsBreadcrumbs } from '../../constants/breadcrumbs';
import labels from '../../constants/labels';
import { routes } from '../../constants/paths';
import PageHeader from '../Common/Headers/PageHeader'; // eslint-disable-line no-unused-vars
import ActionModal from '../Common/ActionContainer/ActionModal'; // eslint-disable-line no-unused-vars

const ManageContacts = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [componentPath, setComponentPath] = useState(null);
  const handleTertiaryButtonClick = (modalProp, path) => {
    setModalData(modalProp);
    setShowModal(true);
    setComponentPath(path);
  };
  const navigatePath = (pathname) => {
    browserHistory.push({
      pathname,
    });
  };

  return (
    <>
      <FxPageContainer>
        <FxBreadcrumbs breadcrumbItems={manageContactsBreadcrumbs} />
        <PageHeader headerText={labels.MANAGE_CONTACTS} />
      </FxPageContainer>

      <FxImageContainer>
        <FxActionCard
          {...manageContactActions.updateContactInfo}
          onPrimaryButtonClick={() => navigatePath(routes.manageContactsContactInfo)}
          onTertiaryButtonClick={() => handleTertiaryButtonClick(
              manageContactActions.updateContactInfo.modalProp,
              routes.manageContactsContactInfo
            )}
        />
        {showModal && (
          <ActionModal
            modalProp={modalData}
            componentPath={componentPath}
            toggleModal={() => setShowModal(false)}
          />
        )}
      </FxImageContainer>
    </>
  );
};

export default ManageContacts;
